/**
 * Script injector
 *
 * @copyright 2018 Linguistica 360
 */


import $ from 'jquery';
import throttle from 'lodash/throttle.js';


let state = {};


export class Script {
    onLoad() {}
    onResize() {}
    onState() {}
    onNewHtml() {}

    wrap(method) {
        var self = this;
        return function () { return method.bind(self)(this); };
    }

    $wrap(method) {
        var self = this;
        return function () { return method.bind(self)($(this)); };
    }

    getGlobalState() {
        return state;
    }

    setState(object, url, replace = false) {
        if (object) Object.assign(state, object);
        if (replace) history.replaceState(state, '', url);
        else history.pushState(state, '', url);
        return history.length - 1;
    }
}

let id = 0;

class Injector {
    constructor() {
        this.classes = [];
    }

    injectClass(Class, classes = []) {
        if (!Array.isArray(classes)) classes = [classes];

        const instance = new Class();

        if (Class.id !== undefined) {
            const index = this.classes.findIndex((instance) => {
                return instance.id === Class.id;
            });

            const old = this.classes[index].classes;

            instance.id = Class.id;
            instance.classes = classes.length ? classes : old;

            this.classes[index] = instance;
        }
        else {
            Class.id = id++;
            instance.id = Class.id;
            instance.classes = classes;

            this.classes.push(instance);
        }

        return Class;
    }

    onLoad() {
        this.filter().forEach((instance) => instance.onLoad());
    }

    onResize() {
        this.filter().forEach((instance) => instance.onResize());
    }

    onState(newstate, init = false) {
        state = newstate;
        this.filter().forEach((instance) => instance.onState(state, init));
    }

    newHtml($ptr) {
        this.filter().forEach((instance) => instance.onNewHtml($ptr));
    }

    filter() {
        return this.classes.filter((instance) => {
            if (instance.classes.length === 0) return true;

            return $('body').attr('class').split(' ').filter((name) => {
                const ic = instance.classes;
                return name[0] === '_' && ic.includes(name.substring(1));
            }).length > 0;
        });
    }
}

export const injector = new Injector();

$(() => {
    injector.onLoad();
    $(window).on('resize', throttle(() => injector.onResize(), 100));
    window.onpopstate = function (e) { injector.onState(e.state || {}); };
    if (history.state) injector.onState(history.state, true);
});
